<mat-card>
    <div class="grid">
        <div class="grid-item">
            <tnb-simple-bars [bars]="bars"></tnb-simple-bars>
        </div>

        <div class="grid-item">
            <table>
                @for (aggregation of aggregations; track aggregation.energieart) {
                    <tr>
                        <td class="label">{{ energieartNameService.getNameForEnergieart(aggregation.energieart) }}</td>
                        <td class="installierte-leistung">{{ aggregation.sum | leistungseinheit:leistungseinheit }}</td>
                    </tr>
                }
            </table>
        </div>
    </div>
</mat-card>
